<template>
  <v-alert
    title="Precios sujetos a cambios"
    type="info"
    variant="tonal"
  ></v-alert>

  <div class="container text-center">
    <div class="row">
      <div class="col-sm-8">
        <ul class="list-group spacing">
          <li
            class="list-group-item active"
            style="background-color: #1866c0"
            aria-current="true"
          >
            Productos
          </li>
          <li v-for="(data, i) in cartItems" :key="i" class="list-group-item">
            <card-carrito-component :data="data" />
          </li>
          <li
            v-for="(item, index) in allCartProducts"
            :key="index"
            class="list-group-item"
          >
            <card-carrito-producto-component :item="item" />
          </li>
        </ul>
      </div>
      <div class="col-sm-4">
        <v-card class="spacing" variant="tonal" color="primary">
          <v-card-text>
            <h3>Resumen</h3>
            <divider-component />
            <v-container>
              <v-row>
                <v-col>
                  <p class="txtdata">Productos ({{ itemCount }})</p>
                </v-col>
                <v-col cols="6" class="d-flex flex-row-reverse">
                  <p class="txtdata">$ {{ totalCartValue }}</p>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col> <p class="txtdata">Total:</p> </v-col>
                <v-col class="d-flex flex-row-reverse">
                  <p class="txtdata" style="color: green">
                    $ {{ totalCartValue }} MXN
                  </p>
                </v-col>
              </v-row>
            </v-container>
            <v-btn
              v-if="BtnActive"
              block
              rounded="lg"
              size="x-large"
              variant="flat"
              color="green"
              @click="enviarMensajeWhatsApp"
              >Solicitar</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import CardCarritoComponent from '@/components/CardCarritoComponent.vue';
import { mapGetters } from 'vuex';
import DividerComponent from '@/components/DividerComponent.vue';
import CardCarritoProductoComponent from '@/components/CardCarritoProductoComponent.vue';

export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    enviarMensajeWhatsApp() {
      let mensaje = 'Hola, estoy interesado en comprar lo siguiente:';
      this.cartItems.forEach((element) => {
        mensaje +=
          '\n* ' +
          element.datos.cantidad +
          ' Pzas - ' +
          element.nombre +
          ' - ' +
          element.datos.medida +
          ' - color: ' +
          element.color.color;
      });

      this.allCartProducts.forEach((element) => {
        mensaje += '\n* ' + element.cantidad + ' Pzas - ' + element.descripcion;
      });

      const numeroWhatsApp = '7731780052'; // Asegúrate de incluir el código de país
      const mensajeCodificado = encodeURIComponent(mensaje);
      const enlaceWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${mensajeCodificado}`;

      // Redirige al usuario
      window.open(enlaceWhatsApp, '_blank');
    },
  },
  computed: {
    BtnActive() {
      if (this.allCartProducts.length > 0 || this.cartItems.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    itemCount() {
      var count =
        Number(this.cartItemCountProduct) +
        Number(this.$store.getters.cartItemCount);
      return count;
    },
    cartWithTotals() {
      return this.$store.getters.cartWithTotals;
    },
    totalCartValue() {
      return (
        Number(this.$store.getters.totalCartValue) + Number(this.totalPriceCart)
      );
    },
    ...mapGetters(['cartItems']),

    ...mapGetters('cartProduct', [
      'totalPriceCart',
      'allCartProducts',
      'cartItemCountProduct',
    ]),
  },
  components: {
    CardCarritoComponent,
    DividerComponent,
    CardCarritoProductoComponent,
  },
};
</script>

<style scoped>
.body {
  background-color: #ededed;
}

.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
}

@media (min-width: 1200px) {
  /* Ajusta este valor según el breakpoint que desees */
  .spacing {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

@media (max-width: 1199px) {
  .spacing {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>
